export default __webpack_public_path__ + "static/media/af.ec83ef62.mp3";